import { extendTheme } from '@chakra-ui/react'

const activeLabelStyles = {
    color: "var(--chakra-colors-chakra-body-text)",
    transform: "scale(0.85) translateY(-24px)"
};

export const theme = extendTheme({
    styles: {
        global: {
            body: {
                bg: 'gray.600'
            },
        },
    },
    components: {
        Form: {
            variants: {
                floatingCard: { // add floating labels on cards
                    container: {
                        _focusWithin: {
                            label: {
                                ...activeLabelStyles
                            }
                        },
                        "input:not(:placeholder-shown) + label, textarea:not(:placeholder-shown) ~ label": {

                            ...activeLabelStyles
                        },
                        ".chakra-select__wrapper + label": {
                            ...activeLabelStyles,
                            color: "var(--chakra-colors-chakra-placeholder-color)"
                        },
                        label: {
                            top: 0,
                            left: 0,
                            zIndex: 2,
                            position: "absolute",
                            backgroundColor: "var(--card-bg)",
                            color: "var(--chakra-colors-chakra-placeholder-color)",
                            fontWeight: "normal",
                            pointerEvents: "none",
                            mx: 3,
                            px: 1,
                            my: 2,
                            transformOrigin: "left top"
                        }
                    }
                },
                floatingDrawer: { // floating labels on drawers
                    container: {
                        _focusWithin: {
                            label: {
                                ...activeLabelStyles
                            }
                        },
                        "input:not(:placeholder-shown) + label, textarea:not(:placeholder-shown) ~ label": {
                            ...activeLabelStyles
                        },
                        ".chakra-select__wrapper + label": {
                            ...activeLabelStyles,
                            color: "var(--chakra-colors-chakra-placeholder-color)"
                        },
                        label: {
                            top: 0,
                            left: 0,
                            zIndex: 2,
                            position: "absolute",
                            backgroundColor: "var(--drawer-bg)",
                            color: "var(--chakra-colors-chakra-placeholder-color)",
                            fontWeight: "normal",
                            pointerEvents: "none",
                            mx: 3,
                            px: 1,
                            my: 2,
                            transformOrigin: "left top"
                        }
                    }
                },
                floatingModal: { // floating labels on drawers
                    container: {
                        _focusWithin: {
                            label: {
                                ...activeLabelStyles
                            }
                        },
                        "input:not(:placeholder-shown) + label, textarea:not(:placeholder-shown) ~ label": {
                            ...activeLabelStyles
                        },
                        ".chakra-select__wrapper + label": {
                            ...activeLabelStyles,
                            color: "var(--chakra-colors-chakra-placeholder-color)"
                        },
                        label:
                        {
                            top: 0,
                            left: 0,
                            zIndex: 2,
                            position: "absolute",
                            backgroundColor: "var(--modal-bg)",
                            color: "var(--chakra-colors-chakra-placeholder-color)",
                            fontWeight: "normal",
                            pointerEvents: "none",
                            mx: 3,
                            px: 1,
                            my: 2,
                            transformOrigin: "left top"
                        }
                    }
                }
            }
        }
    },
    initialColorMode: 'dark',
    useSystemColorMode: false,
});